var DeliveryEstimates;

DeliveryEstimates = window.DeliveryEstimates != null ? window.DeliveryEstimates : window.DeliveryEstimates = {};

DeliveryEstimates.View = require('./views/delivery_estimates');

DeliveryEstimates.Model = require('./models/delivery_estimates');

DeliveryEstimates.init = function(arg, done) {
  var deliveryEstimates;
  deliveryEstimates = arg.deliveryEstimates;
  if (deliveryEstimates == null) {
    return done();
  }
  return $(function() {
    if (deliveryEstimates != null ? deliveryEstimates.fetchSmartDeliveryEstimates : void 0) {
      DealContentLoader.addOnLoadHandler(function() {
        var model;
        model = new DeliveryEstimates.Model({
          dealId: deliveryEstimates.isGISDeal ? deliveryEstimates.dealId : deliveryEstimates.dealUuid,
          isGISDeal: deliveryEstimates.isGISDeal
        });
        return new DeliveryEstimates.View({
          model: model,
          deliveryEstimates: deliveryEstimates
        });
      });
    } else {
      new DeliveryEstimates.View({
        deliveryEstimates: deliveryEstimates
      });
    }
    return done();
  });
};

module.exports = DeliveryEstimates;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWxpdmVyeV9lc3RpbWF0ZXMvZnJvbnRlbmQvZGVsaXZlcnlfZXN0aW1hdGVzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvZGVsaXZlcnlfZXN0aW1hdGVzL2Zyb250ZW5kL2RlbGl2ZXJ5X2VzdGltYXRlcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxpQkFBQSxzQ0FBb0IsTUFBTSxDQUFDLG9CQUFQLE1BQU0sQ0FBQyxvQkFBcUI7O0FBRWhELGlCQUFpQixDQUFDLElBQWxCLEdBQXlCLE9BQUEsQ0FBUSw0QkFBUjs7QUFDekIsaUJBQWlCLENBQUMsS0FBbEIsR0FBMEIsT0FBQSxDQUFRLDZCQUFSOztBQUUxQixpQkFBaUIsQ0FBQyxJQUFsQixHQUF5QixTQUFDLEdBQUQsRUFBc0IsSUFBdEI7QUFDdkIsTUFBQTtFQUR5QixvQkFBRDtFQUN4QixJQUFxQix5QkFBckI7QUFBQSxXQUFPLElBQUEsQ0FBQSxFQUFQOztTQUVBLENBQUEsQ0FBRSxTQUFBO0lBQ0EsZ0NBQUcsaUJBQWlCLENBQUUsb0NBQXRCO01BQ0UsaUJBQWlCLENBQUMsZ0JBQWxCLENBQW1DLFNBQUE7QUFDakMsWUFBQTtRQUFBLEtBQUEsR0FBUSxJQUFJLGlCQUFpQixDQUFDLEtBQXRCLENBQ047VUFBQSxNQUFBLEVBQVcsaUJBQWlCLENBQUMsU0FBckIsR0FBb0MsaUJBQWlCLENBQUMsTUFBdEQsR0FBa0UsaUJBQWlCLENBQUMsUUFBNUY7VUFDQSxTQUFBLEVBQVcsaUJBQWlCLENBQUMsU0FEN0I7U0FETTtlQUdSLElBQUksaUJBQWlCLENBQUMsSUFBdEIsQ0FBMkI7VUFBQyxPQUFBLEtBQUQ7VUFBUSxtQkFBQSxpQkFBUjtTQUEzQjtNQUppQyxDQUFuQyxFQURGO0tBQUEsTUFBQTtNQU9FLElBQUksaUJBQWlCLENBQUMsSUFBdEIsQ0FBMkI7UUFBQyxtQkFBQSxpQkFBRDtPQUEzQixFQVBGOztXQVFBLElBQUEsQ0FBQTtFQVRBLENBQUY7QUFIdUI7O0FBY3pCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
